import {IApiUserProto, space} from "../compiled";
import ContactMethodType = space.kenko.proto.ContactMethodType;

export const isContactEmailVerified = (user: IApiUserProto | null | undefined) => {
  return isClientContactMethodVerified(user, ContactMethodType.EMAIL, user?.contactEmail);
}

export const isMobileNumberVerified = (user: IApiUserProto | null | undefined) => {
  return isClientContactMethodVerified(user, ContactMethodType.MOBILE_PHONE, user?.mobileNumber);
}

const isClientContactMethodVerified = (user: IApiUserProto | null | undefined,
                                       type: ContactMethodType,
                                       emailOrPhone: string | null | undefined) => {

  if (!user || !emailOrPhone || !user.verifiedContactMethods) {
    return false;
  }

  for (let i = 0; i < user.verifiedContactMethods.length; i++) {
    const existing = user.verifiedContactMethods[i];
    if (existing.contactMethod?.type == type &&
        existing.contactMethod.address == emailOrPhone) {
      return true;
    }
  }

  return false;
}